import $axios from '@/helpers/axios-instance';

const baseUrl = process.env.API_SCHOOLS_URL;

export default {
  getUsersReport() {
    return $axios.get('api/v1/Report/users', {
      baseURL: baseUrl,
      responseType: 'blob',
    });
  },
  getTestsReport() {
    return $axios.get('api/v1/Report/tests', {
      baseURL: baseUrl,
      responseType: 'blob',
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/reports.js